module.exports = __webpack_public_path__ + "assets/a96588bce41af9c4a5bad5c331fcf2b9.png";